export default [
	{
	  name: 'Grappe1_Boucle',
	  start: '0:00.000',
	  end: '0:17.391',
	  duration: '0:17.391'
	},
	{
	  name: 'Grappe2_Boucle',
	  start: '0:30.000',
	  end: '1:00.157',
	  duration: '0:30.157'
	},
	{
	  name: 'Grappe3_Boucle',
	  start: '1:30.000',
	  end: '1:53.800',
	  duration: '0:23.800'
	},

	{
	  name: 'Grappe4_Boucle',
	  start: '2:00.000',
	  end: '2:39.480',
	  duration: '0:39.480'
	},
	{
	  name: 'Grappe5_Boucle',
	  start: '3:00.000',
	  end: '3:27.490',
	  duration: '0:27.490'
	},
	{
	  name: 'Grappe6_Boucle',
	  start: '3:30.000',
	  end: '4:03.553',
	  duration: '0:33.553'
	},
	{
	  name: 'Grappe7_Boucle',
	  start: '4:30.000',
	  end: '4:45.596',
	  duration: '0:15.596'
	},
	{
	  name: 'SplashBoucle',
	  start: '5:00.000',
	  end: '5:55.585',
	  duration: '0:55.585'
	},
	{
	  name: 'FinBoucle',
	  start: '6:30.000',
	  end: '12:07.694',
	  duration: '5:37.694'
	},
]



// WEBPACK FOOTER //
// ./src/components/music/music/ambiences.js